import ModelService from "./abstract/ModelService";
import ContractCancellation from "../models/ContractCancellation";

export default class ContractCancellationService extends ModelService {
  constructor(contractId) {
    super('/contracts/' + contractId + '/cancellations', ContractCancellation);
  }
}
